import { render, staticRenderFns } from "./PrintComponent.vue?vue&type=template&id=287d88b8"
import script from "./PrintComponent.vue?vue&type=script&lang=js"
export * from "./PrintComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports